import { COUNTRIES_PHONE_FORMAT } from 'config';
import { MAX_MANUAL_PHONE_LENGTH } from 'view/pages/DiscountEditor/components/CompanyInfoForm/CompanyInfoForm.constants';
import { validatePhoneLength } from './validatePhoneLength';

const BE_PATTERN = /[ -]/g;

export const normalizePhoneNumber = (telephoneNumber: string) =>
  telephoneNumber.replace(BE_PATTERN, '');

const onlyConsistsOfCountryCode = (
  phoneNumber: string,
  country: string | undefined,
) => {
  return (
    !!country &&
    !!COUNTRIES_PHONE_FORMAT[country] &&
    COUNTRIES_PHONE_FORMAT[country]!.countryCode ===
      phoneNumber.replace(/[^\d+]/g, '')
  );
};

export const formatPhoneValueWithMask = (
  value: string,
  country: string | undefined,
) => {
  if (onlyConsistsOfCountryCode(value, country)) {
    return '';
  }

  const inputNumbersValue = value.replace(/\D/g, '');

  if (country && COUNTRIES_PHONE_FORMAT[country]) {
    return COUNTRIES_PHONE_FORMAT[country]!.formatFunction(inputNumbersValue);
  }

  return `+${inputNumbersValue.substring(0, 18)}`;
};

export const formatPhoneValueWithoutMask = (value: string) => {
  const formattedValue = value.replace(/[^\d+()]/g, '');

  const numericLength = formattedValue.replace(/\D/g, '').length;
  const cutBy = numericLength - MAX_MANUAL_PHONE_LENGTH;

  return cutBy > 0 ? formattedValue.slice(0, -cutBy) : formattedValue;
};

export const getValidPhoneNumberLength = (country: string | undefined) => {
  return (
    (country && COUNTRIES_PHONE_FORMAT[country]?.numericLength) ||
    MAX_MANUAL_PHONE_LENGTH
  );
};

export const formatPackedPhoneValue = (
  value: string,
  country: string | undefined,
): string => {
  const isValidMaskLenght = validatePhoneLength({
    phoneNumber: value,
    country,
    isManualCountryCodeInput: false,
    allowEmpty: false,
  });

  if (!isValidMaskLenght) {
    return value;
  }

  const inputNumbersValue = value.replace(/\D/g, '');

  if (country && COUNTRIES_PHONE_FORMAT[country]) {
    return COUNTRIES_PHONE_FORMAT[country]!.formatFunction(inputNumbersValue);
  }

  return value;
};
